import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'

import { Box, CssBaseline, useTheme } from '@mui/material';
import LogTab from './LogTab/LogTab';
import MonthlyCurve from './CurveTab/MonthlyCurve';

function MonthlyReportTab() {
    const [key, setKey] = useState('Energy Log');
    const { spacing } = useTheme()
    return (
        <>
            <CssBaseline />
            <Box sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <Tabs
                    style={{ justifyContent: "flex-start", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Energy Log" title="Energy Log">
                    <LogTab/>
                        
                    </Tab>

                    <Tab eventKey="Energy Curve" title="Energy Curve">
                    <MonthlyCurve/>
                    </Tab>
                    
                </Tabs>
            </Box>
        </>
    )
}

export default MonthlyReportTab
